export default "__VITE_ASSET__CxGRFigE__"